import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const assurances = ['Payment is one-time · No subscription', '100% PDF · sent to your email', '10-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="w-full bg-night" data-id="element-87" data-mp="15cu80ee9ybfj">
      <div className="mx-auto max-w-3xl px-4 py-10 text-center sm:px-5 sm:py-16 lg:py-20" data-id="element-88" data-mp="15c2ct4olafps">
        <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-89" data-mp="1jbk8m40ayt8n">
          Final countdown
        </p>
        <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-90" data-mp="1t3g4r9itw9a8">
          Complete bundle, <span className="text-gold" data-id="element-91" data-mp="1o4ddcrvru1kq">tonight’s price</span>
        </h2>

        <div className="mt-7 sm:mt-8" data-id="element-92" data-mp="222uychuakzyy">
          <Countdown data-id="element-93" data-mp="223w7ggrqzce1" />
        </div>

        <p className="mt-8 text-[10px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:text-xs" data-id="element-94" data-mp="1x4tevvsyeymy">
          6 volumes + 6 free bonuses
        </p>
        <p className="mt-3 flex items-baseline justify-center gap-3" data-id="element-95" data-mp="n7fdpjpo0sax">
          <span className="font-display text-5xl leading-none text-gold sm:text-7xl" data-id="element-96" data-mp="s5qrg5j2zmyf">$27</span>
          <span className="font-display text-xl text-cream-muted line-through sm:text-2xl" data-id="element-97" data-mp="x2qt848we3jq">
            $745
          </span>
        </p>
        <p className="mt-3 text-sm font-semibold text-cream" data-id="element-98" data-mp="120scap6bq2v7">You save $718 today</p>

        <div className="mx-auto mt-7 max-w-md sm:mt-9" data-id="element-99" data-mp="163xboiv3xofm">
          <CtaButton size="large" fullWidth placement="final_countdown" label="Yes, I want to save time and retain more students!" mobileLabel="Yes, I want the bundle — $27" data-id="element-100" data-mp="1b31kh8e4dk5f" />
        </div>

        <ul className="mt-7 flex flex-col items-center gap-2 text-[13px] text-cream-muted sm:mt-8 sm:flex-row sm:justify-center sm:gap-6 sm:text-sm" data-id="element-101" data-mp="1kvfo66ord0u8">
          {assurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-102" data-mp="1tub0m0ieb75z">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-103" data-mp="3qvqhzqpxmujs" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}